interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const LockIcon = (props: PropsType) => {
  return (
    <svg width="25" height="32" viewBox="0 0 25 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M22.5972 10.6362H20.5415V8.02894C20.542 5.81613 19.6397 3.80019 18.1862 2.3515C16.7351 0.900813 14.7159 -0.000999169 12.4995 8.30797e-07C10.2836 -0.000999169 8.26445 0.900813 6.81336 2.3515C5.36033 3.80025 4.45756 5.81613 4.4585 8.02894V10.6362H2.40231C1.0753 10.6362 0 11.7103 0 13.0346V20.6446C0 26.9159 5.59665 32 12.5 32C19.4033 32 25 26.9159 25 20.6446V13.0346C25.0001 11.7103 23.9243 10.6362 22.5972 10.6362ZM13.4107 21.3647L14.1434 24.4913H10.8561L11.5888 21.3643C10.688 21.0034 10.0517 20.1248 10.0517 19.0966C10.0517 17.7466 11.1478 16.6523 12.4995 16.6523C13.8522 16.6523 14.9483 17.7466 14.9483 19.0966C14.9483 20.1248 14.311 21.0034 13.4107 21.3647ZM17.7164 10.6362H7.28356V8.02894C7.28406 6.58563 7.86499 5.29288 8.81127 4.34563C9.75955 3.40088 11.0549 2.82138 12.4995 2.82038C13.9446 2.82138 15.2404 3.40138 16.1888 4.34563C17.1346 5.29288 17.7155 6.58563 17.7164 8.02894V10.6362Z"
        fill={props.color ? props.color : 'white'}
      />
    </svg>
  );
};

export default LockIcon;
